export default __webpack_public_path__ + "static/media/practice-level-4.686d0b81.svg";